import { Container } from 'inversify-props';
import setupUserPasswordModule from './password/setup';
import setupCancelAccountModule from './cancel-account/setup';

export default function setupUserModule(container: Container) {
  setupUserPasswordModule(container);
  setupCancelAccountModule(container);
}
